module.exports = __webpack_public_path__ + "assets/els.53095296.svg";